// @flow
import {
    Box, Button, Layer, Heading, Text, Stack,
} from 'grommet';
import { isEmpty } from 'lodash';
import * as React from 'react';
import { Filter, Close } from 'grommet-icons';
import { FormattedMessage } from 'react-intl';
import { SchemaForm } from 'speed-js-react';


type Props = {
    onSubmit: Function,
    schema: Object,
    initialValues: Object,
    buttonProps: Object,
}


type State = {
    openFilter: boolean,
    filterCount: number,
}

class FilterSidebarLayer extends React.Component<Props, State> {
    static defaultProps = {
        buttonProps: {},
        initialValues: {},
    };

    state = {
        openFilter: false,
        filterCount: 0,
    };

    handleClose = () => {
        this.setState({ openFilter: false });
    };

    handleSubmit = (values: Object, formik: Object) => {
        const { onSubmit } = this.props;
        onSubmit(values, formik);
        this.handleClose();

        this.setState({
            filterCount: Object.values(values)
                .filter((v) => !!v).length,
        });
    };

    handleReset = (values: Object, formik: Object) => {
        const { initialValues } = this.props;
        if (!isEmpty(initialValues)) {
            this.handleSubmit(initialValues, formik);
        } else {
            const newValues = {};
            Object.keys(values).forEach((key) => {
                newValues[key] = null;
            });
            this.handleSubmit(newValues, formik);
        }
    };

    handleOpen = () => {
        this.setState({
            openFilter: true,
        });
    };

    renderForm = (
        props: {
            handleSubmit: (e: SyntheticEvent<HTMLFormElement>) => void,
            handleReset: () => void,
            isSubmitting: boolean,
        },
        fields: { [string]: React.Node },
    ) => {
        const { handleSubmit, handleReset, isSubmitting } = props;

        return (
            <Box as="form" onSubmit={handleSubmit} onReset={handleReset} flex>
                <Box gap="small" justify="start" alignContent="start" overflow="auto" pad="small" flex>
                    {/* $FlowFixMe */}
                    {Object.values(fields)}
                </Box>
                <Box
                    direction="row"
                    margin={{ vertical: 'small' }}
                    gap="small"
                    pad="small"
                >
                    <Box flex height="36px">
                        {/* TODO: i18n */}
                        <Button
                            label={<FormattedMessage id="filters-btn-filter" defaultMessage="Filter" />}
                            type="submit"
                            disabled={isSubmitting}
                            fill
                        />
                    </Box>
                    <Box flex height="36px">
                        <Button
                            label={<FormattedMessage id="filters-btn-reset" defaultMessage="Reset" />}
                            type="reset"
                            disabled={isSubmitting}
                            color="status-error"
                            fill
                        />
                    </Box>
                </Box>
            </Box>
        );
    };

    renderLayer =(
        props: {
            handleSubmit: (e: SyntheticEvent<HTMLFormElement>) => void,
            handleReset: () => void,
            isSubmitting: boolean,
        },
        fields: { [string]: React.Node },
    ) => {
        const { openFilter } = this.state;
        let layer = null;
        if (openFilter) {
            layer = (
                <Layer
                    position="right"
                    full="vertical"
                    modal
                    onEsc={this.handleClose}
                    onClickOutside={this.handleClose}
                    style={{
                        borderRight: '1px solid #3a3a3a',
                        borderRadius: '0px',
                        width: '300px',
                    }}
                >
                    <Box flex>
                        <Box margin={{ bottom: 'small' }} direction="row" pad="small">
                            <Box flex alignContent="center" justify="center">
                                {/* TODO: i18n */}
                                <Heading level={3} textAlign="center">
                                    <FormattedMessage id="filters-title" defaultMessage="Filters" />
                                </Heading>
                            </Box>
                            <Button onClick={this.handleClose} hoverIndicator="light-1" icon={<Close />} />
                        </Box>
                        {this.renderForm(props, fields)}
                    </Box>
                </Layer>
            );
        }

        return layer;
    };

    render() {
        const { schema, buttonProps } = this.props;
        const { filterCount } = this.state;

        return (
            <React.Fragment>
                <Button
                    onClick={this.handleOpen}
                    hoverIndicator="light-1"
                    pad={{ vertical: '10px', horizontal: 'small' }}
                >
                    <Box pad={{ vertical: '10px', horizontal: 'small' }}>
                        <Stack
                            anchor="top-left"
                        >
                            <Box>
                                <Filter />
                            </Box>
                            {(filterCount !== 0) && (
                                <Box
                                    background="red"
                                    pad={{ horizontal: '4px' }}
                                    round
                                    style={{ position: 'relative', top: '-5px', left: '-2px' }}
                                >
                                    <Text weight="bold" color="white" size="10px">{filterCount}</Text>
                                </Box>
                            )}
                        </Stack>
                    </Box>
                </Button>
                <SchemaForm
                    schema={schema}
                    onSubmit={this.handleSubmit}
                    onReset={this.handleReset}
                >
                    {this.renderLayer}
                </SchemaForm>
            </React.Fragment>
        );
    }
}

export default FilterSidebarLayer;
